import { terUtilsUnitsMilimetriToMetri } from './ter-utils';
import { XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { DOT, SLASH, SPACE } from '../utils/frfr-string-consts';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';


/*
export const derivatPoluproizvod_demper_dopuni = (p) => {
  // SPECIJALNI KORAK
  // Demperu dodajemo neke podatke koji su mu potrebni!
  let demper = {
    ...p,
    ..._getParamsFromLib("terkk$demper")
  };
  if (typeof demper.osovina === 'string') {
    demper.osovina = Number.parseInt(demper.osovina); // pretvaramo u broj
  }
  demper.display_brojkrilaca = _derivat_demper_izracunaj_brojkrilaca(p.unutrasnjavisina);
  return demper;
};
*/


//
export const _derivat_demper_izracunaj_naziv = (p) => {
  let naziv = '?';
  let _tipdempera = "?";
  if (p.tipdempera && typeof p.tipdempera.toUpperCase === 'function') {
    _tipdempera = p.tipdempera.toUpperCase();
  }
  naziv = 'DEMPER' + SPACE +
    _tipdempera + SPACE +
    p.unutrasnjasirina + 'x' + p.unutrasnjavisina + SPACE +
    p.vrstapogona + SPACE +
    p.osovina;
  return naziv;
};


/*
export const derivatPoluproizvodDemperOsnovniPodaci = (unutrasnjavisina) => {
  // TODO pretvoriti u PURE funkciju

  // promenljive iz excela
  // const G9 = p.brojkrilaca;
  // Sad se broj krilaca racuna na osnovu unutrasnje VISINE!
  const G9 = _derivat_demper_izracunaj_brojkrilaca(unutrasnjavisina);

  // let demper = p;
  let demper = {};
  demper.visina = '';
  // VISINA =IF(G9>5,IF(G9>9,G9*100+14,(G9*100+12)),(G9*100+11))
  demper.visina = XIF(G9 > 5, XIF(G9 > 9, G9 * 100 + 14, (G9 * 100 + 12)), (G9 * 100 + 11));
  return demper;
};
*/


//
export const _derivat_demper_izracunaj_brojkrilaca = (visinaDempera) => {
  // TODO pretvoriti u PUR funkciju
  let brojKrilica = 0;
  let I4;
  if (visinaDempera && visinaDempera !== '') {
    I4 = visinaDempera;
  }
  // =IF(I4=111,1,IF(I4=211,2,IF(I4=311,3,IF(I4=411,4,IF(I4=511,5,IF(I4=612,6,IF(I4=712,7,IF(I4=812,8,IF(I4=912,9,IF(I4=1014,10,IF(I4=1114,11,IF(I4=1214,12,))))))))))))
  const _OLD_brojKrilica = XIF(I4 === 111, 1, XIF(I4 === 211, 2, XIF(I4 === 311, 3, XIF(I4 === 411, 4, XIF(I4 === 511, 5, XIF(I4 === 612, 6, XIF(I4 === 712, 7, XIF(I4 === 812, 8, XIF(I4 === 912, 9, XIF(I4 === 1014, 10, XIF(I4 === 1114, 11, XIF(I4 === 1214, 12, null))))))))))));
  //
  // STARE VISINE DEMPERA
  // 111,211,311,411,511,612,712,812,912,1014,1114,1214
  // NOVE VISINE DEMPERA
  // NJ: Korekcija unutrašnje visine dempera #224 Potrebno je u odabiru visina dempera promeniti sve visine da se završavaju na "11".
  // 111,211,311,411,511,611,711,811,911,1011,1111,1211
  if (I4 === 111) {
    brojKrilica = 1;
  } else if (I4 === 211) {
    brojKrilica = 2;
  } else if (I4 === 311) {
    brojKrilica = 3;
  } else if (I4 === 411) {
    brojKrilica = 4;
  } else if (I4 === 511) {
    brojKrilica = 5;
  } else if (I4 === 612 || I4 === 611) {
    brojKrilica = 6;
  } else if (I4 === 712 || I4 === 711) {
    brojKrilica = 7;
  } else if (I4 === 812 || I4 === 811) {
    brojKrilica = 8;
  } else if (I4 === 912 || I4 === 911) {
    brojKrilica = 9;
  } else if (I4 === 1014 || I4 === 1011) {
    brojKrilica = 10;
  } else if (I4 === 1114 || I4 === 1111) {
    brojKrilica = 11;
  } else if (I4 === 1214 || I4 === 1211) {
    brojKrilica = 12;
  } else {
    brojKrilica = null;
  }
  //
  return brojKrilica;
};


//


export const derAutoCreateVirbom_terkk_demper_prepare_vir_input = (p) => {

  const H27 = p.unutrasnjasirina;
  const H28 = _derivat_demper_izracunaj_brojkrilaca(p.unutrasnjavisina);
  const kolicina = p.kolicina;
  const vrstapogona = p.vrstapogona;

  const v_input = {
    unutrasnjasirina: H27,
    brojkrilaca: H28,
    kolicina,
    vrstapogona
  };

  return v_input;
};

export const derAutoCreateVirbom_terkk_demper_children = (v_input) => {
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // promenljive iz excela
  const H27 = v_input.unutrasnjasirina;
  // console.log('** Unutrasnja sirina demper ', p.unutrasnjasirina);
  // Sad se broj krilaca racuna na osnovnu unutrasnje VISINE
  const H28 = v_input.brojkrilaca;
  const kolicina = v_input.kolicina;
  const vrstapogona = v_input.vrstapogona;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // derivat 1 duzina =(H27+70)
  // derivat local 1
  _derivat_key = "PD 1001";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$demper$derivat1',
    virtelclass: "terkk$demper$profil",
    kolicina: 2,
    duzina: 0,
  };
  x.duzina = (H27 + 70);
  x.calculated_ident = 'PROF0001';
  x.naziv = 'PROFIL AL DEMPER PD 1001 PD01 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = 'PPD01AA00000';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$demper$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 5 kolicina=H28 duzina=H40
  // derivat local 1.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_demper_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$demper$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 2 duzina =IF(H28>5,IF(H28>9,H28*100+14,(H28*100+12)),(H28*100+11))
  // derivat local 2
  _derivat_key = "PD 1002";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$demper$derivat1',
    virtelclass: "terkk$demper$profil",
    kolicina: 2,
    duzina: 0,
  };
  x.duzina = XIF(H28 > 5, XIF(H28 > 9, H28 * 100 + 14, (H28 * 100 + 12)), (H28 * 100 + 11));
  const H39 = x.duzina;
  x.calculated_ident = 'PROF0002';
  x.naziv = 'PROFIL AL DEMPER PD 1002 PD02 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = 'PPD02AA00000';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$demper$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 2.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_demper_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$demper$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 3 kolicina =IF(H27>1250,(H28*2),(H28))
  // derivat local 3
  _derivat_key = "PD 1000";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$demper$derivat1',
    virtelclass: "terkk$demper$profil",
  };
  x.kolicina = XIF(H27 > 1250, (H28 * 2), (H28));
  // duzina =IF(H27>1250,((H27-35)/2)-3,H27-3)
  x.duzina = XIF(H27 > 1250, ((H27 - 35) / 2) - 3, H27 - 3);
  const H40 = x.duzina;
  x.calculated_ident = 'PROF0003';
  x.naziv = 'PROFIL AL DEMPER PD 1000 PD00 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = 'PPD00AA00000';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$demper$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 3.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_demper_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$demper$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 4 kolicina=IF(H27>1250,1,0)
  // derivat local 4
  _derivat_key = "PD 1003";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$demper$derivat1',
    virtelclass: "terkk$demper$profil",
  };
  x.kolicina = XIF(H27 > 1250, 1, 0);
  // console.log('x.kolicina', x.kolicina);
  // kolicina=IF(H27>1250,H39,0)
  x.duzina = XIF(H27 > 1250, H39, 0);
  x.calculated_ident = 'PROF0004';
  x.naziv = 'PROFIL AL DEMPER PD 1003 PD03 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = 'PPD03AA00000';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$demper$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;

  // Ako je broj komada za ovaj element 0 onda izbrisi ovaj derivat
  // if (z["PD 1003"].kolicina === 0) {
  if (z[_derivat_key].kolicina === 0) {
    delete z[_derivat_key];
    // _level1_counter -= 1; // smanjujemo counter jer smo izbacili ovaj element
  } else {
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
    // derivat local 4.1
    _derivat_key = _derivat_key + '_m';
    _mat = _derivat_demper_materijal1_by_pp(x);
    xm = {
      ..._mat,
      _derivat_key,
      virtelschemakey: 'terkk$demper$materijal1',
    };
    z[_derivat_key] = xm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
  }


  // ZATIM SLEDI JOS 4 MATERIJALA ZA DEMPER


  // derivat 5 kolicina=H28 duzina=H40
  // derivat local 5 MATERIJAL
  _derivat_key = "G 0012";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$demper$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_M,
    // kolicina: H28,
    duzina: XIF(H27 > 1250, ((H27 - 35) / 2) - 3, H27 - 3),
    tip: ''
  };
  // DL 2023-11-28: _derivat_key = "G 0012"; nema dobru kolicinu sada je kolicina jednaka broju krilaca kolicina: H28 a treba da bude broj krilaca pomnozen sa duzinom krilaca konvertovano u metre kolicina: H28*duzina/1000
  x.kolicina = H28 * x.duzina / 1000;
  x.calculated_ident = 'B100010000000064';
  x.naziv = 'OSTALO ZAPTIVACI G0012';
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 6 kolicina=IF(H27>1250,(H28*2),H28)
  // derivat local 6 MATERIJAL
  _derivat_key = "NG 100 (NG001-NG006)";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$demper$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_KOM,
    tip: ''
  };
  // x.kolicina = XIF(H27 > 1250, (H28 * 2), H28);
  // DL 2023-11-28: _derivat_key = "NG 100 (NG001-NG006)" treba da se računaju 2 po krilcu, bez obzira da li je dupli ili iz demper iz jednog dela. Sada je x.kolicina = XIF(H27 > 1250, (H28 * 2), H28); a treba da bude uvek x.kolicina =H28 * 2
  x.kolicina = H28 * 2;
  x.duzina = ''; // Trazio da bude prazano
  x.calculated_ident = 'B100010000000091';
  x.naziv = 'OSTALO DEMPER ZUPCANIK NG 100';
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 7
  _derivat_key = "A 840";
  if (vrstapogona === 'rucni') {
    // derivat local 7 MATERIJAL
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$demper$materijal2',
      terkategorija: 'M',
      jm: tclocal.JM_KOM,
      kolicina: 1,
      duzina: '', // Trazio da bude prazano
      tip: ''
    };
    x.calculated_ident = 'B080000000000006';
    x.naziv = 'RUCICA ALUMINIJUM A 840 PRO-LAM ALLUMINIO S.R.L.';
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
  }


  // derivat 8 kolicina=IF(H27>1250,2,1)
  // derivat local 8 MATERIJAL
  _derivat_key = "AP 190";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$demper$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_KOM,
    kolicina: 1,
    duzina: '', // Trazio da bude prazano
    tip: ''
  };
  x.kolicina = XIF(H27 > 1250, 2, 1);
  x.calculated_ident = 'B100010000000085';
  x.naziv = 'OSTALO DEMPER OSOVINA AP 190';
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // DL 2023-11-28: Treba dodati jos jedan materijal kada je izabrana vrsta pogona motorni PPD08AA000006000 - PROFIL AL DEMPER PD 1008 NOSAC MOTORNOG POGONA PD84 SIROV 6000mm Kolicina je : 0,12 m
  // derivat 9
  _derivat_key = "PD 1008";
  if (vrstapogona === 'motorni') {
    // derivat local 7 MATERIJAL
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$demper$materijal2',
      terkategorija: 'M',
      jm: tclocal.JM_M,
      kolicina: 0.12,
      duzina: '', // Trazio da bude prazano
      tip: ''
    };
    x.calculated_ident = 'PPD08AA000006000';
    x.naziv = 'PROFIL AL DEMPER PD 1008 NOSAC MOTORNOG POGONA PD84 SIROV 6000mm';
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
  }


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
}


const _derivat_demper_materijal1_by_pp = (p) => {

  // TODO: proveriti da li i p prima prirubnicu kao input ili daje kao rezultat...

  const _materijal_priprema_ulaza = (p) => {
    const _materijal_naziv = p._materijal_naziv;
    const tip = p.tip;
    const duzina = p.duzina;
    const v_input = {
      tip,
      duzina,
      _materijal_naziv
    };
    return v_input;
  };

  const _mat_make = (v_input) => {
    // dodajem mu materijal!
    // let z;
    let x = {
      virtelschemakey: 'terkk$demper$materijal1',
      naziv: v_input._materijal_naziv
    };
    x.calculated_ident = v_input.tip;
    x.terkategorija = 'M';
    let _kolicina = v_input.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    x.kolicina = terUtilsUnitsMilimetriToMetri(_kolicina, 3); // KONVERTUJEMO U METRE
    x.jm = tclocal.JM_M;
    // z["derivat2"] = x;
    // posto materijal nece na backendu da se cuva odmah ovde delimicno kompletiramo virtel plitki
    const virtel_plitki_materijal = {
      // ...v_input,
      ...x
    };
    return virtel_plitki_materijal;

    // TODO: ovde imamo dva puta polje kolicina
  };

  const v_input = _materijal_priprema_ulaza(p);
  const materijal = _mat_make(v_input);
  return materijal;
};

